import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AMFIUService } from './api/aMFIU.service';
import { AboutSaccosPolicyService } from './api/aboutSaccosPolicy.service';
import { AccountService } from './api/account.service';
import { AccountStatusService } from './api/accountStatus.service';
import { AccountTransactionsService } from './api/accountTransactions.service';
import { AdminUserService } from './api/adminUser.service';
import { ApexService } from './api/apex.service';
import { AppModuleService } from './api/appModule.service';
import { AppModuleFeatureService } from './api/appModuleFeature.service';
import { AssetAllocationService } from './api/assetAllocation.service';
import { AuditService } from './api/audit.service';
import { AuditLogService } from './api/auditLog.service';
import { BlockEmailAddressAppserviceService } from './api/blockEmailAddressAppservice.service';
import { BranchService } from './api/branch.service';
import { BulkTransactionService } from './api/bulkTransaction.service';
import { CamsAuthService } from './api/camsAuth.service';
import { CamsTransactionService } from './api/camsTransaction.service';
import { ChargeTypeService } from './api/chargeType.service';
import { ClientLoanService } from './api/clientLoan.service';
import { ClientManagerService } from './api/clientManager.service';
import { ClientRegistrationService } from './api/clientRegistration.service';
import { ClientStatusService } from './api/clientStatus.service';
import { ClientTypeService } from './api/clientType.service';
import { ClientUserService } from './api/clientUser.service';
import { ConfigurationService } from './api/configuration.service';
import { CreditProductPolicyService } from './api/creditProductPolicy.service';
import { CreditUnionService } from './api/creditUnion.service';
import { CreditUnionAssociatedService } from './api/creditUnionAssociated.service';
import { CreditUnionChargeService } from './api/creditUnionCharge.service';
import { CreditUnionConfigurationService } from './api/creditUnionConfiguration.service';
import { CreditUnionFeatureService } from './api/creditUnionFeature.service';
import { CreditUnionFinancialDataService } from './api/creditUnionFinancialData.service';
import { CreditUnionGetService } from './api/creditUnionGet.service';
import { CreditUnionGroupService } from './api/creditUnionGroup.service';
import { CreditUnionMemberService } from './api/creditUnionMember.service';
import { CreditUnionMemberChargeService } from './api/creditUnionMemberCharge.service';
import { CreditUnionMemberDetailService } from './api/creditUnionMemberDetail.service';
import { CreditUnionMemberDocumentService } from './api/creditUnionMemberDocument.service';
import { CreditUnionMemberSearchService } from './api/creditUnionMemberSearch.service';
import { CreditUnionMemberSummaryService } from './api/creditUnionMemberSummary.service';
import { CreditUnionMigrationService } from './api/creditUnionMigration.service';
import { CreditUnionPaymentProviderService } from './api/creditUnionPaymentProvider.service';
import { CreditUnionStatusService } from './api/creditUnionStatus.service';
import { CreditUnionUpdateService } from './api/creditUnionUpdate.service';
import { CreditUnoinUserService } from './api/creditUnoinUser.service';
import { CreditunionDocumentService } from './api/creditunionDocument.service';
import { DashboardService } from './api/dashboard.service';
import { ExternalAuthServiceService } from './api/externalAuthService.service';
import { ExternalCreditService } from './api/externalCredit.service';
import { FileService } from './api/file.service';
import { FinancialDataApprovalService } from './api/financialDataApproval.service';
import { GroupAssetsServiceService } from './api/groupAssetsService.service';
import { GroupDetailServiceService } from './api/groupDetailService.service';
import { GroupDetailsSaveService } from './api/groupDetailsSave.service';
import { GroupDocumentServiceService } from './api/groupDocumentService.service';
import { GroupLoanService } from './api/groupLoan.service';
import { GroupMemberServiceService } from './api/groupMemberService.service';
import { HolidaysService } from './api/holidays.service';
import { HostUserService } from './api/hostUser.service';
import { InterestRateService } from './api/interestRate.service';
import { InvestmentProductService } from './api/investmentProduct.service';
import { InvoiceService } from './api/invoice.service';
import { JobService } from './api/job.service';
import { LoanService } from './api/loan.service';
import { LoanAccountDetailsService } from './api/loanAccountDetails.service';
import { LoanAccruedService } from './api/loanAccrued.service';
import { LoanApplicationService } from './api/loanApplication.service';
import { LoanApplicationChargeService } from './api/loanApplicationCharge.service';
import { LoanApplicationCreateService } from './api/loanApplicationCreate.service';
import { LoanApplicationDetailService } from './api/loanApplicationDetail.service';
import { LoanApplicationDocumentService } from './api/loanApplicationDocument.service';
import { LoanApplicationListService } from './api/loanApplicationList.service';
import { LoanApplicationMemberService } from './api/loanApplicationMember.service';
import { LoanApplicationScheduleService } from './api/loanApplicationSchedule.service';
import { LoanApplicationStageService } from './api/loanApplicationStage.service';
import { LoanApplicationStatusService } from './api/loanApplicationStatus.service';
import { LoanBalanceService } from './api/loanBalance.service';
import { LoanChargesService } from './api/loanCharges.service';
import { LoanCollateralService } from './api/loanCollateral.service';
import { LoanConstService } from './api/loanConst.service';
import { LoanDetailService } from './api/loanDetail.service';
import { LoanDisbursementService } from './api/loanDisbursement.service';
import { LoanDocumentService } from './api/loanDocument.service';
import { LoanGuarantorService } from './api/loanGuarantor.service';
import { LoanInstallmentService } from './api/loanInstallment.service';
import { LoanInsuranceService } from './api/loanInsurance.service';
import { LoanListService } from './api/loanList.service';
import { LoanMemberService } from './api/loanMember.service';
import { LoanOfficerService } from './api/loanOfficer.service';
import { LoanOverPaidAmountService } from './api/loanOverPaidAmount.service';
import { LoanProductService } from './api/loanProduct.service';
import { LoanProvisioningService } from './api/loanProvisioning.service';
import { LoanRepaymentService } from './api/loanRepayment.service';
import { LoanRescheduleService } from './api/loanReschedule.service';
import { LoanSectorTypeService } from './api/loanSectorType.service';
import { LoanStatementService } from './api/loanStatement.service';
import { LoanTopUpService } from './api/loanTopUp.service';
import { LoanTypeService } from './api/loanType.service';
import { LoanUpdateService } from './api/loanUpdate.service';
import { MemberBankAccountService } from './api/memberBankAccount.service';
import { MemberDetailsService } from './api/memberDetails.service';
import { MemberDetailsAssetsService } from './api/memberDetailsAssets.service';
import { MemberDetailsIncomeService } from './api/memberDetailsIncome.service';
import { MemberDetailsResidenceService } from './api/memberDetailsResidence.service';
import { MemberDetailsSavingsService } from './api/memberDetailsSavings.service';
import { MemberDetailsShareService } from './api/memberDetailsShare.service';
import { MemberFinancialDataService } from './api/memberFinancialData.service';
import { MemberKycService } from './api/memberKyc.service';
import { MemberKycDocumentService } from './api/memberKycDocument.service';
import { MemberMnoService } from './api/memberMno.service';
import { MemberTreasuryService } from './api/memberTreasury.service';
import { MembershipPolicyService } from './api/membershipPolicy.service';
import { NotificationService } from './api/notification.service';
import { OnlineTransactionService } from './api/onlineTransaction.service';
import { OrganizationChargeConfigService } from './api/organizationChargeConfig.service';
import { OverdueLoanCategoryService } from './api/overdueLoanCategory.service';
import { PayTransactionService } from './api/payTransaction.service';
import { PaymentService } from './api/payment.service';
import { PaymentProviderService } from './api/paymentProvider.service';
import { PaymentTransactionModeService } from './api/paymentTransactionMode.service';
import { PaymentTypeConfigurationService } from './api/paymentTypeConfiguration.service';
import { PayrollDeductionService } from './api/payrollDeduction.service';
import { PolicyApprovalService } from './api/policyApproval.service';
import { PolicyMemberAcceptanceService } from './api/policyMemberAcceptance.service';
import { PolicyVersionService } from './api/policyVersion.service';
import { ReconcileService } from './api/reconcile.service';
import { ReportService } from './api/report.service';
import { RequestService } from './api/request.service';
import { RoleService } from './api/role.service';
import { SavingAccountService } from './api/savingAccount.service';
import { SavingConstService } from './api/savingConst.service';
import { SavingProductService } from './api/savingProduct.service';
import { SecurityService } from './api/security.service';
import { ServiceProviderService } from './api/serviceProvider.service';
import { SessionService } from './api/session.service';
import { SettingsService } from './api/settings.service';
import { ShareAccountService } from './api/shareAccount.service';
import { ShareTypeService } from './api/shareType.service';
import { TellerService } from './api/teller.service';
import { TellerAccountService } from './api/tellerAccount.service';
import { TellerGuarantorAccountService } from './api/tellerGuarantorAccount.service';
import { TellerProductService } from './api/tellerProduct.service';
import { TellerRequestService } from './api/tellerRequest.service';
import { TellerTransactionService } from './api/tellerTransaction.service';
import { TenantService } from './api/tenant.service';
import { TokenAuthService } from './api/tokenAuth.service';
import { TransactionService } from './api/transaction.service';
import { TransactionFeeService } from './api/transactionFee.service';
import { TransactionFeeConfigurationService } from './api/transactionFeeConfiguration.service';
import { TransactionSecurityService } from './api/transactionSecurity.service';
import { UserService } from './api/user.service';
import { UserAcceptInviteService } from './api/userAcceptInvite.service';
import { UserAccountService } from './api/userAccount.service';
import { UserActivatationService } from './api/userActivatation.service';
import { UserDeviceService } from './api/userDevice.service';
import { UserInviteService } from './api/userInvite.service';
import { UserSettingsService } from './api/userSettings.service';
import { UssdService } from './api/ussd.service';
import { UssdLoanService } from './api/ussdLoan.service';
import { UssdSavingService } from './api/ussdSaving.service';
import { UssdSharesService } from './api/ussdShares.service';
import { WakandiAuthService } from './api/wakandiAuth.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
